import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useDisclosure,
  // eslint-disable-next-line no-restricted-imports
  Icon as ChakraIcon,
} from '@chakra-ui/react';
import { Menu as MenuIcon } from 'lucide-react';
import { SidebarContent } from './SidebarContent';
import { IconButton } from 'src/components/atoms/IconButton';
import { YapamarLogo } from 'src/components/atoms/YapamarLogo';
import { useColorModeValue } from '@chakra-ui/react';

export const SideNavBar = ({ children }: { children: React.ReactNode }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const logoTheme = useColorModeValue('dark', 'white');

  return (
    <Box minH="100vh" bg="surface.page">
      {/* Desktop sidebar */}
      <SidebarContent display={{ base: 'none', lg: 'block' }} />

      {/* Mobile drawer */}
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        size="full">
        <DrawerOverlay />
        <DrawerContent>
          <SidebarContent onClose={onClose} pos="relative" w="full" />
        </DrawerContent>
      </Drawer>

      {/* Mobile-only header: drawer trigger + logo */}
      <Flex
        display={{ base: 'flex', lg: 'none' }}
        h="14"
        alignItems="center"
        px={4}
        bg="surface.sidebar"
        borderBottomWidth="1px"
        borderBottomColor="surface.border">
        <IconButton
          onClick={onOpen}
          aria-label="open menu"
          icon={<ChakraIcon as={MenuIcon} boxSize={6} />}
          variant="ghost"
          mr={2}
        />
        <YapamarLogo theme={logoTheme} />
      </Flex>

      <Box ml={{ base: 0, lg: '280px' }}>{children}</Box>
    </Box>
  );
};
